import UserList from './../../components/users/partner_view/List'
import { createApp } from 'vue';

if (document.getElementById('partner-users')) {

    const app = createApp({
        components: {
            'user-list': UserList
        }
    });
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#partner-users');
}